import { TicketsWrapper } from './styles';
import { getEventDetails } from '@store/slices/eventSlice';
import { useSelector } from 'react-redux';
import { TicketItem } from './items/TicketItem';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

declare global {
  interface Window {
    tito?: (...args: any[]) => void;
  }
}

export interface Ticket {
  attendee_type: string;
  additional_status: boolean;
  code: string;
  description: string;
  event: any;
  external_link: {
    type: string;
    url: string;
  };
  extra_options: any[];
  hidden: number;
  id: string;
  included_options: any[];
  name: string;
  onsite: number;
  package: string;
  price: number;
  currency: string;
  priority: number;
  updated_at: string | Date;
  visibility: string;
  external_public_discount: string | null;
}

export interface TicketsProps {
  tickets: Ticket[];
  hasBorderTop?: boolean;
  hasFullContent: boolean;
}

export const Tickets = ({
  tickets,
  hasBorderTop,
  hasFullContent = true,
}: TicketsProps) => {
  const { t } = useTranslation();
  const sluggedEvent = useSelector(getEventDetails)?.[0];

  useEffect(() => {
    const interval = setInterval(() => {
      const buttons = document.querySelectorAll('.tito-submit');

      buttons.forEach(button => {
        button.textContent = t('buy-now-btn');
      });
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <TicketsWrapper color={sluggedEvent?.design?.themeColor}>
      {tickets.map((ticket, index) => {
        return (
          <TicketItem
            hasBorderTop={hasBorderTop}
            hasBorderBottom={index !== tickets.length - 1}
            hasFullContent={hasFullContent}
            key={`ticket-item-${ticket.id || ''}`}
            ticket={ticket}
          />
        );
      })}
    </TicketsWrapper>
  );
};

export default Tickets;
